export const NAMESPACE = "EventActivities";

export const WIDTH = 880;
